import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { FuseqHeaders } from '../../FuseQ/fuseq.headers'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
@Injectable({
  providedIn: 'root'
})
export class AwpDashboardApiService {
  constructor (private readonly http: HttpClient, private readonly fuseqHeaders: FuseqHeaders) { }

  // da sostituire con api dashboard
  Get_InstallationGrouByMonth (year): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpDashboard/Get_InstallationGrouByMonth/${year}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_RollbackGrouByMonth (year): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpDashboard/Get_RollbackGrouByMonth/${year}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_ReschedulingByMonth (year): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpDashboard/Get_ReschedulingByMonth/${year}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_Pianificabili (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpDashboard/Get_Pianificabili`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_PianificabiliInstallati (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpDashboard/Get_PianificabiliInstallati`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_AvgInstallation (year): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpDashboard/Get_AvgInstallation/${year}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_GlobalReport (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpDashboard/Get_GlobalReport`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_DailyReport (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpDashboard/Get_DailyReport`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  GetCoworking_InstallationGrouByMonth (year): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpDashboard/GetCoworking_InstallationGrouByMonth/${year}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_InstallationGrouByMonthCisco (year): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpDashboard/Get_InstallationGrouByMonthCisco/${year}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_RollbackGrouByMonthCisco (year): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpDashboard/Get_RollbackGrouByMonthCisco/${year}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_ReschedulingByMonthCisco (year): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpDashboard/Get_ReschedulingByMonthCisco/${year}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_PianificabiliInstallatiCisco (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpDashboard/Get_PianificabiliInstallatiCisco`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_AvgInstallationCisco (year): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpDashboard/Get_AvgInstallationCisco/${year}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_GlobalReportCisco (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpDashboard/Get_GlobalReportCisco`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_DailyReportCisco (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpDashboard/Get_DailyReportCisco`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }
}
